import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getAllApplicantsData, getDashboardData, updateApplicant, UpdateApplicantPayload } from "../apiconfig/api";

interface DashboardState {
  applicantsData: any | null;
  data: any | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

interface ApplicantsDataParams {
  lastActiveStartUtc: string;
  lastActiveEndUtc: string;
  zipCode: string;
  positions: string[];
  verifiedPhone: boolean | null;
  hasVideo: boolean | null;
  hasResume: boolean | null;
  superApplied: boolean | null;
  minRating: number | null;
  maxRating: number | null;
  isActive: boolean | null;
  isPublished: boolean | null;
  isGloballyVisible: boolean | null;
  fullNameLike: string | null;
  page: any;
  limit: any;
  sort: string;
  userUuid?: string;
}

export const fetchDashboardData = createAsyncThunk<any>(
  "dashboard/fetchData",
  async () => {
    const response = await getDashboardData();
    return response;
  }
);



export const fetchAllApplicantsData = createAsyncThunk<any, ApplicantsDataParams>(
  "admin/fetchApplicantData",
  async (payload) => {
    const response = await getAllApplicantsData(payload);
    return response;
  }
);

export const updateApplicantThunk = createAsyncThunk<any,{ applicantId: string | number; data: UpdateApplicantPayload}
>("admin/updateApplicant", async ({ applicantId, data }) => {
  const res = await updateApplicant(applicantId, data);
  return res;                                 
});

const initialState: DashboardState = {
  data: null,
  applicantsData: null,
  status: "idle",
  error: null,
};

const adminDashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "Failed to fetch dashboard data";
      })
       .addCase(fetchAllApplicantsData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAllApplicantsData.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = "succeeded";
        state.applicantsData = action.payload;
      })
      .addCase(fetchAllApplicantsData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "Failed to fetch dashboard data";
      })
      .addCase(updateApplicantThunk.fulfilled,(s,a) => {
        s.status = "succeeded";
        const updated = a.payload; 
        if (s.data?.applicants) {
          const idx = s.data.applicants.findIndex(
            (appl: { id: string | number }) => appl.id === updated.id
          );
          if (idx !== -1) s.data.applicants[idx] = updated;
        }
      })
      .addCase(updateApplicantThunk.rejected,  (s,a) => {
        s.status = "failed";
        s.error  = a.error.message ?? "Failed to update person";
      });
  },
});

export default adminDashboardSlice.reducer;
